import { Star, Quote } from "lucide-react";
import { REVIEWS } from "../data/site";
import { Reveal, Overline } from "./Reveal";
import { useI18n } from "../i18n/LanguageContext";

const Stars = ({ rating }) => (
  <div className="flex gap-1" aria-label={`${rating}/5`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        aria-hidden
        className={`w-4 h-4 ${i < rating ? "fill-wood text-wood" : "text-pine/20"}`}
      />
    ))}
  </div>
);

export const Reviews = () => {
  const { t } = useI18n();
  return (
    <section data-testid="reviews-section" className="bg-white/60 py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Overline>{t("reviews.overline")}</Overline>
            <h2 className="font-serif text-4xl md:text-6xl tracking-tighter text-pine mt-4 leading-[1.05]">
              {t("reviews.title1")}
              <span className="italic text-wood-dark">{t("reviews.title2a")}</span>
            </h2>
          </div>
          <p className="text-ink/50 text-sm max-w-xs">{t("reviews.sub")}</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-px bg-pine/10 mt-16 border border-pine/10">
          {REVIEWS.map((review, i) => (
            <Reveal key={review.name} delay={i * 0.08} y={24}>
              <article data-testid={`review-card-${i}`} className="bg-cream p-8 md:p-12 h-full flex flex-col">
                <Quote aria-hidden className="w-8 h-8 text-wood/50 mb-6" />
                <p className="text-ink/80 leading-relaxed flex-1 text-base md:text-lg font-serif italic">
                  « {review.text} »
                </p>
                <div className="mt-8 pt-6 border-t border-pine/10 flex items-center justify-between">
                  <div>
                    <p className="font-semibold text-pine">{review.name}</p>
                    <p className="text-sm text-ink/50">{review.location} — {review.date}</p>
                  </div>
                  <Stars rating={review.rating} />
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
